import { Reveal } from "./Reveal";
import { WaButton } from "./WaButton";

export default function ConversaoAssistida() {
  return (
    <section className="py-16 md:py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <Reveal>
          <div
            data-testid="hidropro-assisted-conversion-card"
            className="grid grid-cols-1 items-stretch overflow-hidden rounded-2xl border-2 border-dashed border-[#0A5C8C]/40 bg-white lg:grid-cols-2"
          >
            <div className="flex flex-col justify-center p-8 sm:p-12">
              <p className="font-mono text-xs uppercase tracking-[0.25em] text-[#0A5C8C]">Não sabe qual serviço precisa?</p>
              <p className="mt-4 font-display text-xl font-bold leading-snug tracking-tight text-[#1A1A1A] sm:text-2xl lg:text-[1.7rem]">
                Não sabe exatamente qual serviço precisa? Explique o que está acontecendo, informe sua localização e, se
                possível, envie fotos ou vídeos pelo WhatsApp. Nossa equipe analisará as informações e orientará sobre
                as possibilidades de atendimento.
              </p>
              <div className="mt-8">
                <WaButton testId="hidropro-assisted-whatsapp-button" />
              </div>
            </div>
            <figure className="relative min-h-[240px]">
              <img
                src="https://images.unsplash.com/photo-1676210133055-eab6ef033ce3?crop=entropy&cs=srgb&fm=jpg&q=85"
                alt="Técnico HidroPro analisando tubulação sob a pia"
                loading="lazy"
                className="absolute inset-0 h-full w-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-r from-white/60 via-transparent to-transparent lg:from-white/30" />
              <figcaption className="absolute bottom-4 right-4 rounded-full bg-brand-ink/85 px-4 py-1.5 font-mono text-[10px] uppercase tracking-[0.2em] text-white backdrop-blur">
                Explique o problema pelo WhatsApp
              </figcaption>
            </figure>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
